import lodash from 'lodash';

/**
 * MDC stores comparison values as text. Match scalar record values by their text
 * representation; missing values and objects never match. Any matching condition
 * hides the node, but only within the configured namespace and relation.
 */
export default function isHiddenForValue(conditions, record, { namespace, relation } = {}) {
    return !!conditions?.some(({ foreignNamespace, foreignRelation, propertyName, value }) => {
        if (foreignNamespace && foreignNamespace !== namespace) return false;
        if (foreignRelation && foreignRelation !== relation) return false;
        if (!propertyName || value == null) return false;
        const recordValue = lodash.get(record, propertyName);
        return ['string', 'number', 'boolean'].includes(typeof recordValue) && String(recordValue) === value;
    });
}
